import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common-services/common.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import * as EmailValidator from 'email-validator';
import { noNumericAfterDotComValidator } from 'src/app/shared/numeric-after-dot-validator';
import { CartService } from '../../../services/cart.service';
import { UserType } from 'src/app/shared/constants/constants';

@Component({
  selector: 'app-login-popup',
  templateUrl: './login-popup.component.html',
  styleUrls: ['./login-popup.component.scss'],
})
export class LoginPopupComponent {
  baseUrl = environment.BASE_URL;
  portalUrl: string = environment.PORTAL_URL;
  loginForm!: FormGroup;
  rememberMe: FormControl = new FormControl('');
  hide: boolean = true;
  urlParams: any;
  companyid!: number;
  isCustomer:boolean = true;
  userType!:UserType;
  constructor(
    private dialogRef: MatDialogRef<LoginPopupComponent>,
    private router: Router,
    private commonService: CommonService,
    private cartService: CartService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private dialog: MatDialog,
  ) {
    this.createLoginForm();
  }
  ngOnInit() {
    this.rememberEmailAndPassword();
    //this.getUrlData();
    this.tokenInfo();
    this.dialog.openDialogs.forEach((openedDialogInstance: MatDialogRef<any>, index) => {
      if (index != 0) {
        openedDialogInstance.close();
      }
    });
  }
  chekCartData() {
    let cartLocalData: any = sessionStorage.getItem('cartData');
    if (cartLocalData) {
      let dataItem = JSON.parse(cartLocalData);
      let responseArray = Object.values(dataItem);
      responseArray.forEach((product: any) => {
        this.addToCart(product);
      });
    }
  }
  closeLoginPopup(isTrue: Boolean) {
    if (isTrue) {
    }
    this.dialogRef.close(isTrue);
  }
  // getUrlData(): void {
  //   this.urlParams = this.commonService.getUrlParams();
  // }
  rememberEmailAndPassword() {
    this.rememberMe.valueChanges.subscribe({
      next: (res: any) => {
        if (res) {
          sessionStorage.setItem('customeruserEmail', this.loginForm.value.email);
          sessionStorage.setItem('customerpassword', this.loginForm.value.passWord);
        } else {
          sessionStorage.removeItem('customeruserEmail');
          sessionStorage.removeItem('customerpassword');
        }
      },
    });
  }

  createLoginForm() {
    const email = sessionStorage.getItem('customeruserEmail');
    const password = sessionStorage.getItem('customerpassword');
    this.loginForm = this.fb.group({
      email: new FormControl(email || '', [
        Validators.required,
        Validators.email,
        noNumericAfterDotComValidator(),
      ]),
      passWord: new FormControl(password || '', [Validators.required]),
    });
  }

  onSubmit() {
    const APIUrl = `${this.baseUrl}auth-service/login`;
    const payload = {
      userName: this.loginForm.value.email,
      email: this.loginForm.value.email,
      passWord: this.commonService.encryptData(this.loginForm.value.passWord),
    };
    this.commonService.postDatawithoutHeaders(APIUrl, payload).subscribe({
      next: (res: any) => {
        const token = res?.response?.idToken;
        sessionStorage.setItem('customerToken', token);
        let jwt = res.response.idToken;
        let tokens = jwt.split('.');
        let idToken = JSON.parse(atob(tokens[1]));
        let userId = idToken['custom:userid'];
        sessionStorage.setItem('customeruserId', userId);
        let companyId = idToken['custom:companyId'];
        sessionStorage.setItem('customercompanyId', companyId);
        let accessToken = res.response.accessToken;
        let refreshToken = res.response.refreshToken;
        sessionStorage.setItem('customerAccessToken', accessToken);
        sessionStorage.setItem('customerRefreshToken', refreshToken);
        this.companyid = idToken['custom:companyId'];
        this.getPermissionsData(userId);
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error.status.error.message);
      },
    });
  }

  togglePasswordVisibility() {
    this.hide = !this.hide;
  }

  isValid() {
    if (
      this.loginForm.controls['email'].status === 'INVALID' ||
      this.loginForm.controls['passWord'].status === 'INVALID'
    ) {
      return true;
    } else {
      return false;
    }
  }
  get validateEmail() {
    return EmailValidator.validate(this.loginForm.value.email);
  }
  getPermissionsData(userId: any) {
    let apiURL = `${this.baseUrl}auth-service/role-permission-management/${userId}`;
    this.commonService.getData(apiURL).subscribe({
      next: (res: any) => {
        this.chekCartData();
        this.closeLoginPopup(true);
        sessionStorage.removeItem('cartData');
        if (res) {
          sessionStorage.setItem('customerpermissionsData', JSON.stringify(res));
          this.router.navigateByUrl(this.router.url);
          this.cartService.getCartItems(this.companyid);
          this.commonService.checkToken();
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
    });
  }
  tokenInfo() {
    const customerToken = sessionStorage.getItem('customerToken');
    const customercompanyId = sessionStorage.getItem('customercompanyId');
    const customerpermissionsData = sessionStorage.getItem('customerpermissionsData');
    const customeruserId = sessionStorage.getItem('customercompanyId');
    let token = customerToken?.split('.');
    let customerEmail;
    if (token?.length) {
      let idToken = JSON.parse(atob(token[1]));
      customerEmail = idToken['email'];
    }
    if (customerToken && customercompanyId && customerpermissionsData && customeruserId) {
      this.router.navigateByUrl('/');
    }
  }
  addToCart(product: any) {
    let payLoad = {
      productId: product.productId,
      productName: product.productName,
      quantity: product.quantity,
      date: product.date,
      cmsCatName: product.cmsCatName,
      cmsSubCatName: product.cmsSubCatName,
      companyId: this.companyid,
      imageUrl: product.imageUrl,
      rfqTemplate: product.rfqTemplate,
      tags: product.tags,
    };
    let apiUrl = `${this.baseUrl}rfq/cart/addCart`;
    this.commonService.postDatawithoutHeaders(apiUrl, payLoad).subscribe((data) => {
      this.cartService.getCartItems(this.companyid);
    });
  }

  redirectToForgotPassword(): void {
    this.dialogRef.close(true);
    this.router.navigateByUrl('/login/forget-password');
  }

  closePopUp() {
    this.dialog.closeAll();
  }
  customerSignup(){
    this.dialogRef.close();
    this.router.navigateByUrl('/user-register');
    //this.router.navigateByUrl('/registration');
  }
  validateUser(){
    if (!this?.loginForm?.value?.email) {
      this.isCustomer = false;
      return;
    }
   if(this.loginForm.get('email')?.errors)
   {
      this.isCustomer = false;
      return;
   }
    let apiurl = `${this.baseUrl}auth-service/user-management/getUserDetailByEmail?emailId=${this.loginForm.value.email}`;
    this.commonService.getData(apiurl).subscribe({
      next: (data: any) => {
        let userData:any = data?.response
        if(userData.userType === UserType.Customer){
          this.isCustomer = true;
        } else{
          this.isCustomer = false;
          this.loginForm.controls['email'].setErrors({ incorrect: true });
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error?.error?.status?.error?.identifier) {
          this.toastr.error(error?.error?.status?.error?.identifier);
        }
      },
    });
  }
}
